import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import { useDocumentLibraryTranslations } from '../../hooks';
export function showReviewAccessPermissionsDialog(params) {
    showCustomDialog({
        content: (close, ariaTitleId, ariaContentId) => (React.createElement(ReviewAccessPermissionsDialog, { ariaTitleId: ariaTitleId, ariaContentId: ariaContentId, action: params.action, onClose: close, onContinue: params.onContinue })),
    });
}
const ReviewAccessPermissionsDialog = ({ onClose, onContinue, ariaContentId, action, ariaTitleId, }) => {
    const { t } = useDocumentLibraryTranslations();
    const actionTranslation = t(`reviewAccessPermissionsDialog.actions.${action}`);
    return (React.createElement(Box, { "data-test": 'review-access-permissions-dialog' },
        React.createElement(DialogTitle, { id: ariaTitleId }, t('reviewAccessPermissionsDialog.title', { action: actionTranslation })),
        React.createElement(DialogContent, { id: ariaContentId },
            React.createElement(Alert, { severity: 'info' },
                React.createElement(Typography, null, t('reviewAccessPermissionsDialog.content', { action: actionTranslation.toLowerCase() })))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => onClose(), "data-test": 'cancel' }, t('common.cancel')),
            React.createElement(Button, { onClick: () => onClose(() => onContinue()), "data-test": 'continue' }, t('common.continue')))));
};
